import { Flex, Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import PermissionPlaceholder from "../../../components/PermissionPlaceholder"
import useHealthAccessRestricted from "../../../hooks/useHealthAccessRestricted"
import { useIsStripeConnected } from "../../hooks/useIsStripeConnected"
import ConnectStripePlaceholder from "../ConnectStripePlaceholder/ConnectStripePlaceholder"
import MastercardEstimatedProgramStatusTable from "./Table/MastercardEstimatedProgramStatusTable"

import "./MastercardEstimatedProgramStatus.less"

const { Text } = Typography

const MastercardEstimatedProgramStatus = ({ business_account_id }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isRestricted = useHealthAccessRestricted()
  const { isMobile } = useSelector((state) => state.nav)
  const isStripeConnected = useIsStripeConnected()

  const handleViewAll = () => {
    navigate("mastercard_estimated_program_status")
  }

  return (
    <div className="mc-estimated-program-status-wrap">
      <div className="mc-estimated-program-status">
        <Flex className="header" align="flex-start" justify="space-between" gap={10}>
          <Text>Estimated program status</Text>
          {!isRestricted && !isMobile && (
            <ButtonComponent onClick={handleViewAll}>{t("View All")}</ButtonComponent>
          )}
        </Flex>

        {isRestricted ? (
          <PermissionPlaceholder minHeight={300} />
        ) : (
          <div
            className={cls("mc-stripe-gated-content", {
              "is-stripe-disconnected": !isStripeConnected
            })}
            style={!isStripeConnected ? { minHeight: 300 } : undefined}
          >
            <MastercardEstimatedProgramStatusTable
              business_account_id={business_account_id}
              variant="block"
              pageSize={5}
            />
            {!isStripeConnected && <ConnectStripePlaceholder />}
          </div>
        )}
      </div>

      {!isRestricted && isMobile && (
        <ButtonComponent
          style={{ width: "100%", marginTop: 16, height: 40 }}
          onClick={handleViewAll}
        >
          {t("View All")}
        </ButtonComponent>
      )}
    </div>
  )
}

export default MastercardEstimatedProgramStatus
